import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef } from 'react';
import styled from 'styled-components';
import Spacer from './Spacer';
import { useToastDispatch } from './Toast/ToastProvider';

const Container = styled.div`
  display: flex;
  &:hover {
    background: #f8f9ff;
  }
  padding: 4px 13px;
  border-radius: 19px;
  cursor: pointer;
`;

const Text = styled.div``;

const CopyIcon = styled.div`
  color: #9092c1;
`;

type Props = {
  children: React.ReactNode;
};

export default function CopyText({ children }: Props) {
  const ref = useRef(null);
  const dispatch = useToastDispatch();
  return (
    <Container
      onClick={(evt) => {
        evt.stopPropagation();
        if (!ref || ref.current == null) return;

        if (window.getSelection == null) {
          return;
        }
        var selection = window.getSelection();
        var range = document.createRange();
        const curr: any = ref.current;
        if (ref.current) range.selectNodeContents(curr);
        selection?.removeAllRanges();
        selection?.addRange(range);
        document.execCommand('Copy');
        selection?.removeAllRanges();

        dispatch({
          alert: 'success',
          text: 'Text copied',
        });
      }}
    >
      <Text ref={ref}>{children}</Text>
      <Spacer horizontal spacing={2} />
      <CopyIcon>
        <FontAwesomeIcon icon={faCopy} />
      </CopyIcon>
    </Container>
  );
}
